import axios from 'axios';
import environment from '@src/environment';
import utils from '@src/utils/utils';
import moment from 'moment';

export const state = {
  groceryList: [],
  selectedItem: null,
  isListActive: false,
  isShowModal: false,
};

export const getters = {};

export const mutations = {
  setGroceryList(state, value) {
    state.groceryList = value;
  },
  setDeleteGroceryItem(state, value) {
    const categoryIndex = state.groceryList.findIndex((category) => {
      if (value.category) {
        return category.id === value.category.id;
      } else {
        return category.id === value.ingredient.category.id;
      }
    });

    const itemIndex = state.groceryList[categoryIndex].groceryItems.findIndex((item) => {
      if (value.category) {
        return item.id === value.category.id;
      } else {
        return item.ingredient.id === value.ingredient.id;
      }
    });

    state.groceryList[categoryIndex].groceryItems.splice(itemIndex, 1);
  },
  setDeleteGroceryStapleItem(state, value) {
    const categoryIndex = state.groceryList.findIndex((category) => {
      if (value.category) {
        return category.id === value.category.id;
      } else {
        return category.id === value.ingredient.category.id;
      }
    });

    const stapleItemIndex = state.groceryList[categoryIndex].stapleItems.findIndex((item) => {
      if (value.isStaple) {
        return item.ingredient.id === value.ingredient.id;
      }
    });

    state.groceryList[categoryIndex].stapleItems.splice(stapleItemIndex, 1);
  },
  setUpdateGroceryItem(state, value) {
    const categoryIndex = state.groceryList.findIndex((category) => {
      if (value.category) {
        return category.id === value.category.id;
      } else {
        return category.id === value.isCustom ? value.id : value.ingredient.category.id;
      }
    });

    const itemIndex = state.groceryList[categoryIndex].groceryItems.findIndex((item) => item.id === value.id);

    value.isChecked = !value.isChecked;
    state.groceryList[categoryIndex].groceryItems[itemIndex] = value;
  },
  setNewGroceryItem(state, value) {
    const i = state.groceryList.findIndex((item) => item.id == value.categoryId);
    state.groceryList[i].groceryItems.push(value.res || value.item);
  },
  setSelectedItem(state, value) {
    state.selectedItem = value;
  },
  setToggleList(state, value) {
    state.isListActive = !state.isListActive;
  },
  setShowModal(state, value) {
    state.isShowModal = !state.isShowModal;
  },
};

export const actions = {
  async getShoppingData(ctx, { today = moment(), startDate = moment(), endDate = moment(), preset = '7 days' } = {}) {
    const todayIso = utils.setToMidNight(new Date(today)).toISOString();
    const startDateIso = utils.setToMidNight(new Date(startDate)).toISOString();
    const endDateIso = utils.setToMidNight(new Date(endDate)).toISOString();
    const params = `?today=${todayIso}&startDate=${startDateIso}&endDate=${endDateIso}&preset=${preset}`;

    return await axios
      .get(`${environment.GET_SHOPPING_DATA_URL}${params}`)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  async getGroceryList(ctx, { today = moment(), startDate = moment(), endDate = moment(), preset = '7 days' } = {}) {
    const todayIso = utils.setToMidNight(new Date(today)).toISOString();
    const startDateIso = utils.setToMidNight(new Date(startDate)).toISOString();
    const endDateIso = utils.setToMidNight(new Date(endDate)).toISOString();
    const params = `?today=${todayIso}&startDate=${startDateIso}&endDate=${endDateIso}&preset=${preset}`;

    return await axios
      .get(`${environment.GROCERY_LIST_URL}${params}`)
      .then((res) => ctx.commit('setGroceryList', res.data))
      .catch((err) => console.log(err));
  },
  async shareGroceryList(ctx, payload = {}) {
    return await axios
      .post(`${environment.GROCERY_LIST_URLSHARE}`, payload)
      .then((res) => res.data)
      .catch((err) => err);
  },

  async addGroceryListItem(ctx, payload) {
    return await axios
      .post(`${environment.CREATE_GROCERY_LIST_ITEM_URL}`, payload)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  async addGroceryListStapleItem(ctx, ingredientItemIds) {
    return await axios
      .put(`${environment.ADD_GROCERY_LIST_STAPLE_ITEM_URL}`, { ingredientItemIds })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  async updateGroceryListItem(ctx, payload) {
    return await axios
      .put(`${environment.UPDATE_GROCERY_LIST_ITEM_URL}/${payload.id}`, { isChecked: payload.isChecked })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  async deleteGroceryListItem(ctx, ingredientItemIds) {
    return await axios
      .post(`${environment.DELETE_GROCERY_LIST_ITEM_URL}`, { ingredientItemIds })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
};
